import {Autocomplete, createFilterOptions, TextField} from "@mui/material";
import {states} from "../constants";

// Create a custom filter that matches either label or code
const filterOptions = createFilterOptions({
    matchFrom: 'any',
    stringify: (option) => `${option.label} ${option.value}`,
});

const StateSelector = ({ name, onChange, value }) => {
    return (
        <Autocomplete
            options={states}
            getOptionLabel={(option) => option.label}
            filterOptions={filterOptions}
            renderInput={(params) => (
                <TextField {...params} label="State" variant="outlined" />
            )}
            value={states.find((state) => state.value === value) || null}
            onChange={(event, newValue) => {
                onChange({
                    target: {
                        name: name,
                        value: newValue ? newValue?.value : null,
                    },
                });
            }}
            isOptionEqualToValue={(option, value) => {
                return option.code === value?.code;
            }}
            fullWidth
        />
    );
}

export default StateSelector;
